import Phaser from 'phaser';
import { narrator } from './Narrator.js';

/** Min. cel dotykowy 64 px (§4, R4). */
export const MIN_TOUCH = 64;

export type ButtonOpts = {
  x: number;
  y: number;
  label: string;
  fill?: number;
  textColor?: string;
  onClick: () => void;
  width?: number;
  height?: number;
  /** Stabilna nazwa GameObjectu (diagnostyka i real-click E2E). */
  name?: string;
};

export const UiKit = {
  button(scene: Phaser.Scene, opts: ButtonOpts): Phaser.GameObjects.Container {
    const w = Math.max(opts.width ?? 220, MIN_TOUCH);
    const h = Math.max(opts.height ?? MIN_TOUCH, MIN_TOUCH);
    const fill = opts.fill ?? 0xffb6c1;
    const bg = scene.add
      .rectangle(0, 0, w, h, fill)
      .setOrigin(0.5)
      .setStrokeStyle(3, 0xffffff)
      .setInteractive({ useHandCursor: true });
    const label = scene.add
      .text(0, 0, opts.label, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '22px',
        color: opts.textColor ?? '#4a3f55',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    const c = scene.add.container(opts.x, opts.y, [bg, label]);
    if (opts.name) {
      c.setName(opts.name);
      bg.setName(`${opts.name}-hit`);
    }
    // kontener też interaktywny (niektóre przeglądarki lepiej łapią)
    c.setSize(w, h);
    c.setInteractive(
      new Phaser.Geom.Rectangle(-w / 2, -h / 2, w, h),
      Phaser.Geom.Rectangle.Contains,
    );
    let firing = false;
    const fire = (
      pointer?: Phaser.Input.Pointer,
      _localX?: number,
      _localY?: number,
      event?: { stopPropagation?: () => void },
    ) => {
      event?.stopPropagation?.();
      pointer?.event?.stopPropagation?.();
      if (firing) return;
      firing = true;
      // Dotyk / klik: czytaj etykietę równolegle z akcją (bez dodatkowych kroków).
      narrator.sayText(opts.label, { immediate: true });
      scene.tweens.add({
        targets: c,
        scaleX: 0.96,
        scaleY: 0.96,
        duration: 80,
        yoyo: true,
        onComplete: () => {
          firing = false;
          opts.onClick();
        },
      });
    };
    // Desktop: hover z debouncem 300 ms w Narratorze.
    const onHover = () => {
      narrator.sayText(opts.label);
    };
    bg.on('pointerover', onHover);
    c.on('pointerover', onHover);
    bg.on('pointerdown', fire);
    c.on('pointerdown', fire);
    return c;
  },
};
